var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-diff"},_vm._l((_vm.changes),function(ref){
var field = ref.field;
var before = ref.before;
var after = ref.after;
return _c('div',{key:field,staticClass:"change"},[_c('p',[_vm._v(_vm._s(_vm.$helpers.formatTitle(field)))]),_c('div',{staticClass:"diff"},[_c('div',{staticClass:"before",class:{ empty: !before }},[_vm._v("\n        "+_vm._s(before || "--")+"\n      ")]),_c('div',{staticClass:"after",class:{ empty: !after }},[_vm._v(_vm._s(after || "--"))])])])}))}
var staticRenderFns = []

export { render, staticRenderFns }